export default __webpack_public_path__ + "static/media/youtube.b62c61f7.svg";